import { eases } from "library/eases"
import { fresponsive } from "library/fullyResponsive"
import styled, { css, keyframes } from "styled-components"
import colors from "styles/colors"

export default function FacilitiesThree() {
	return (
		<>
			<Rect />
			<Rect />
			<Rect />
			<Rect />
		</>
	)
}

const slide = keyframes`
  0% {
    transform: rotate(var(--rotate)) translate(0, 0);
    animation-timing-function: ${eases.quint.inOut};
  }

  25% {
    transform: rotate(var(--rotate))  translate(0, var(--translate));
    opacity:1;
  }

  25.001% {
    opacity: 0;
  }

  50% {
    transform:  rotate(var(--rotate)) translate(0, var(--translate));
    opacity: 0;
  }

  50.001% {
    transform: rotate(var(--rotate))  translate(0, 0);
    opacity: 1;
  }

  100% {
    transform:  rotate(var(--rotate)) translate(0, 0);
  }
`

const Rect = styled.div`
	position: absolute;
	border: 1px solid ${colors.blue3};
	animation: ${slide} 8s infinite;

	${fresponsive(css`
		--translate: 28.2px;
		--padding: 8px;

		border-radius: 4px;
		width: 20px;
		height: 20px;

		&:nth-child(1) {
			top: var(--padding);
			left: var(--padding);
			animation-delay: 0s;
			--rotate: 0deg;
		}

		&:nth-child(2) {
			top: var(--padding);
			right: var(--padding);
			animation-delay: 2s;
			--rotate: 90deg;
		}

		&:nth-child(3) {
			bottom: var(--padding);
			right: var(--padding);
			animation-delay: 4s;
			--rotate: 180deg;
		}

		&:nth-child(4) {
			bottom: var(--padding);
			left: var(--padding);
			animation-delay: -2s;
			--rotate: -90deg;
		}
	`)}
`
